var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('special-issue-form',{attrs:{"special-issue":_vm.initialEnterpriseData}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page_title"},[_vm._v("\n      專刊資料確認\n    ")])])
}]

export { render, staticRenderFns }